import Skeleton from '@mui/material/Skeleton';
export const SkeletonImage = () => {

  return (<Skeleton variant="rectangular" width={180} height={118} />)
}

export default SkeletonImage